/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './edit-device.scss';

/* eslint-disable import/no-unresolved, import/default */

import deviceCredentialsTemplate from '../../../../../device/device-credentials.tpl.html';
import editDeviceTemplate from './edit-device.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.editDevice', [])
    .directive('agEditDevice', EditDevice)
    .name;

/*@ngInject*/
function EditDevice() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            userMode: '='
        },
        controller: EditDeviceController,
        controllerAs: 'vm',
        templateUrl: editDeviceTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function EditDeviceController($rootScope, $scope, $timeout, $document, $mdDialog, $translate, agTypes, userService, agDeviceService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === "CUSTOMER_USER";
    vm.device = null;
    vm.deviceTypes = [];
    for (var deviceType in agTypes.deviceType) {
        vm.deviceTypes.push(agTypes.deviceType[deviceType]);
    }
    vm.agTypes = agTypes;

    vm.manageCredentials = manageCredentials;
    vm.save = save;
    vm.cancel = cancel;

    var defaultTitle = $translate.instant('ag.device.device');

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.ctx.widgetTitle = defaultTitle;
        }
    });

    $scope.$watch(function() { return vm.device ? vm.device.name : defaultTitle; }, function(title) {
        if (vm.showData && vm.ctx) {
            vm.ctx.widgetTitle = title;
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$on('deviceSelected', function(event, deviceId) {
        if (vm.showData) {
            reload(deviceId);
        }
    });

    function reload(deviceId) {
        if (!vm.device || !angular.equals(vm.device.id, deviceId)) {
            vm.loading = true;
            vm.origDevice = null;
            vm.device = null;
            if (deviceId) {
                agDeviceService.getDevice(deviceId).then(
                        function success(device) {
                            vm.origDevice = device;
                            vm.device = angular.copy(device);
                            vm.loading = false;
                            resetFormState();
                        }
                );
            } else {
                vm.loading = false;
            }
        }
    }

    function resetFormState() {
        $timeout(function() {
            vm.theForm.$setPristine();
            vm.theForm.$setUntouched();
        });
    }

    function manageCredentials($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: 'ManageDeviceCredentialsController',
            controllerAs: 'vm',
            templateUrl: deviceCredentialsTemplate,
            locals: {deviceId: vm.device.id.id, isReadOnly: false},
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
        }, function () {
        });
    }

    function cancel() {
        vm.device = angular.copy(vm.origDevice);
        resetFormState();
    }

    function save() {
        agDeviceService.saveDevice(vm.device).then(function success(device) {
            vm.origDevice = device;
            vm.device = angular.copy(device);
            vm.theForm.$setPristine();
            vm.theForm.$setUntouched();
            $rootScope.$broadcast('deviceUpdated', vm.origDevice);
        });
    }

}

